/**
 *  Элемент ссылки
 */
export class NavItem {

    to = ''
    label = ''
    title = ''

    /**
     * @param {string} to Ссылка, но если символ `|` то будет разедлитель
     * @param {string} label
     * @param {string} title
     */
    constructor({to, label, title}) {
        this.to = to
        this.label = label
        this.title = title
    }

    /**
     * @param {AppRoute} route
     */
    static fromAppRoute( route ){
        return new NavItem({
            to:     route.link,
            label:  route.label,
            title:  ''
        })
    }

    /**
     *  @param {AppRoute[]} routes
     *  @returns {NavItem[]}
     */
    static listFromAppRoutes(routes){
        return routes.filter( route => route.link!=null ).map( route => NavItem.fromAppRoute(route) )
    }


}